import { FunctionComponent, MouseEvent } from "react";
import { types } from "src/utils";

const { buttonTypes } = types;

interface IButtonProps {
  text: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  theme?: types.buttonTypes.BUTTON_THEME_TYPES;
  type?: 'submit';
  styles?: string;
  testId?: string;
  cyId?: string;
  disabled?: boolean;
  id?: string;
}

const Button: FunctionComponent<IButtonProps> = ({
  text,
  onClick,
  styles,
  theme,
  type,
  testId,
  disabled = false,
  cyId,
  id,
}) => {
  const themeStyles =
    types.buttonTypes.BUTTON_THEME_STYLES[
      theme || buttonTypes.BUTTON_THEME_TYPES.PRIMARY
    ];

  return (
    <button
      className={`
        ${buttonTypes.buttonBaseStyles} 
        ${themeStyles} 
        ${styles} 
        relative overflow-hidden
        transition-transform duration-150
        hover:scale-105
        active:scale-95
        hover:shadow-strong
        focus:outline-none focus:ring-2 focus:ring-primary
        before:absolute before:inset-0 before:bg-gradient-to-r before:from-primary-light before:via-secondary-light before:to-primary-light before:opacity-30 before:blur-xl before:transition-all before:duration-500 before:scale-x-0 before:origin-left hover:before:scale-x-100
      `}
      onClick={onClick}
      data-testid={testId}
      type={type}
      disabled={disabled}
      data-cy={cyId}
      id={id}
    >
      <span className="relative z-10">{text}</span>
    </button>
  );
};

export default Button;
